const buttonStyles = (theme) => ({
  root: { [theme.breakpoints.down('sm')]: { textAlign: 'center' } },
  button: {
    [theme.breakpoints.down('sm')]: { display: 'block', width: '100%' },
  },
});

export default buttonStyles;
